import { render, staticRenderFns } from "./DocsModal.vue?vue&type=template&id=05d828de&"
import script from "./DocsModal.vue?vue&type=script&lang=js&"
export * from "./DocsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports